





























import Vue from 'vue'
import PullTo from 'vue-pull-to'
import { $, requestAnimationFrame, cancelAnimationFrame } from '@/utils/helpers'

export default Vue.extend({
  name: 'PullRefresh',
  components: { PullTo },
  props: {
    onRefresh: {
      type: Function,
      default: null
    },
    wrapperHeight: {
      type: String,
      default: '100%'
    },
    scrollMonitorSelector: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      frameID: null,
      isTopBounce: true,
      oldScrollTop: 0,
      refreshTimer: null,
      scrollTop: 0,
      target: null,
      done: false
    }
  },
  computed: {
    topConfig(): any {
      return {
        stayDistance: 80
      }
    },

    style(): any {
      return {
        height: this.done ? '100%' : 'auto'
      }
    }
  },
  watch: {
    scrollMonitorSelector(val: string) {
      if (val) {
        this.target = this.getTarget(val)
        this.target.addEventListener('scroll', this.monitorScroll, false)
      } else {
        this.target.removeEventListener('scroll', this.monitorScroll, false)
      }
    }
  },
  mounted() {
    this.target = this.getTarget(this.scrollMonitorSelector)
    this.target.addEventListener('scroll', this.monitorScroll, false)
  },
  destroyed() {
    this.target.removeEventListener('scroll', this.monitorScroll, false)
  },
  methods: {
    getTarget(selector: string): Element | Window {
      return selector ? $(selector) || window : window
    },

    loadedTop(loaded) {
      if (this.refreshTimer || this.scrollTop > window.screen.height / 10) {
        return
      }
      this.refreshTimer = setTimeout(async () => {
        await this.onRefresh()
        this.refreshTimer = null
        loaded('done')
        // 読み込み完了後に .vue-pull-to-wrapper の 'translate3d(0px, 0px, 0px);' を削除することで下方向へのスクロールが可能になる
        this.done = true
      }, 1000)
    },

    /**
     * 下方向の bounce を禁止することで下にスクロールできるようになったが今度は上方向にスクロールできなくなった
     * 対策として上スワイプ時はスクロール値が一定値になるまでは上方向の bounce を禁止する
     */
    monitorScroll() {
      if (this.frameID) {
        return
      }
      this.frameID = requestAnimationFrame(async () => {
        this.scrollTop = this.target === window ? window.pageYOffset : this.target.scrollTop
        const isScrollUp = this.oldScrollTop > this.scrollTop

        if ((isScrollUp && this.scrollTop <= 50) || this.scrollTop === 0) {
          // ある要素のなかでスクロールしていた場合完全には上までスクロールできていないので
          // window をスクロールさせて pull refresh を完全に表示させる
          this.isTopBounce = true
        } else {
          this.isTopBounce = false
        }

        cancelAnimationFrame(this.frameID)
        this.oldScrollTop = this.scrollTop
        this.frameID = null
      })
    }
  }
})
